import { render, staticRenderFns } from "./UserOnline.vue?vue&type=template&id=4a530851&scoped=true&"
import script from "./UserOnline.vue?vue&type=script&lang=ts&"
export * from "./UserOnline.vue?vue&type=script&lang=ts&"
import style0 from "./UserOnline.vue?vue&type=style&index=0&id=4a530851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a530851",
  null
  
)

export default component.exports